/* @generated */
// prettier-ignore
if (Intl.DisplayNames && typeof Intl.DisplayNames.__addLocaleData === 'function') {
  Intl.DisplayNames.__addLocaleData({
  "data": {
    "patterns": {
      "locale": "{0} ({1})"
    },
    "types": {
      "calendar": {
        "long": {
          "buddhist": "বৌদ্ধ ক্যালেন্ডার",
          "chinese": "চীনা ক্যালেন্ডার",
          "coptic": "কপটিক ক্যালেন্ডার",
          "dangi": "দাঙ্গী ক্যালেন্ডার",
          "ethiopic": "ইথিওপিক ক্যালেন্ডার",
          "ethiopic-amete-alem": "ইথিওপিও আমেতে আলেম ক্যালেন্ডার",
          "gregorian": "গ্রিগোরিয়ান ক্যালেন্ডার",
          "hebrew": "হিব্রু ক্যালেন্ডার",
          "indian": "ভারতীয় জাতীয় বর্ষপঞ্জী",
          "islamic": "ইসলামিক ক্যালেন্ডার",
          "islamic-civil": "ইসলামিক-সিভিল বর্ষপঞ্জী",
          "islamic-rgsa": "ইসলামিক বর্ষপঞ্জী (সৌদি আরব, দৃশ্যমান)",
          "islamic-tbla": "ইসলামিক বর্ষপঞ্জী (ছকবদ্ধ, জ্যোতির্বিদ্যীয় যুগ)",
          "islamic-umalqura": "ইসলামিক বর্ষপঞ্জী (উম্মা আল-কুরআ)",
          "iso8601": "ISO-861 ক্যালেন্ডার",
          "japanese": "জাপানি ক্যালেন্ডার",
          "persian": "ফারসি ক্যালেন্ডার",
          "roc": "মিঙ্গুও ক্যালেন্ডার"
        },
        "narrow": {
        },
        "short": {
        }
      },
      "currency": {
        "long": {
          "ADP": "এ্যান্ডোরান পেসেতা",
          "AED": "সংযুক্ত আরব আমিরাত দিরহাম",
          "AFA": "আফগানি (১৯২৭–২০০২)",
          "AFN": "আফগান আফগানি",
          "ALK": "ALK",
          "ALL": "আলবেনিয়ান লেক",
          "AMD": "আরমেনিয়ান দ্রাম",
          "ANG": "নেদারল্যান্ড এ্যান্টিলিয়ান গুল্ডের",
          "AOA": "এ্যাঙ্গোলান কওয়ানজা",
          "AOK": "এ্যাঙ্গোলান কওয়ানজা (১৯৭৭–১৯৯০)",
          "AON": "এ্যাঙ্গোলান নতুন কওয়ানজা (১৯৯৫–২০০০)",
          "AOR": "এ্যাঙ্গোলান কওয়ানজা (১৯৯৫–১৯৯৯)",
          "ARA": "আর্জেন্টিনা অস্ট্রাল",
          "ARL": "ARL",
          "ARM": "ARM",
          "ARP": "আর্জেন্টিনা পেসো (১৯৮৩–১৯৮৫)",
          "ARS": "আর্জেন্টিনা পেসো",
          "ATS": "অস্ট্রিয়ান শিলিং",
          "AUD": "অস্ট্রেলিয়ান ডলার",
          "AWG": "আরুবা গিল্ডার",
          "AZM": "আজারবাইজান মানাত (১৯৯৩–২০০৬)",
          "AZN": "আজারবাইজান মানাত",
          "BAD": "বসনিয়া এবং হার্জেগোভিনা দিনার",
          "BAM": "বসনিয়া এবং হার্জেগোভিনা বিনিমেয় মার্ক",
          "BAN": "BAN",
          "BBD": "বার্বেডোজ ডলার",
          "BDT": "বাংলাদেশী টাকা",
          "BEC": "বেলজিয়ান ফ্রাঙ্ক (রূপান্তরযোগ্য)",
          "BEF": "বেলজিয়ান ফ্রাঙ্ক",
          "BEL": "বেলজিয়ান ফ্রাঙ্ক (আর্থিক)",
          "BGL": "বুলগেরীয় হার্ড লেভ",
          "BGM": "BGM",
          "BGN": "বুলগেরীয় লেভ",
          "BGO": "BGO",
          "BHD": "বাহরাইনি দিনার",
          "BIF": "বুরুন্ডি ফ্রাঙ্ক",
          "BMD": "বারমিউডান ডলার",
          "BND": "ব্রুনেই ডলার",
          "BOB": "বলিভিয়ানো",
          "BOL": "BOL",
          "BOP": "বলিভিয়ান পেসো",
          "BOV": "বলিভিয়ান মভডোল",
          "BRB": "ব্রাজিলিয়ান ক্রুজেয়রোনোভো (১৯৬৭–১৯৮৬)",
          "BRC": "ব্রাজিলিয়ান ক্রুজেইডাউ",
          "BRE": "ব্রাজিলিয়ান ক্রুজেয়রো (১৯৯০–১৯৯৩)",
          "BRL": "ব্রাজিলিয়ান রিয়েল",
          "BRN": "ব্রাজিলিয়ান ক্রুজেইডো নোভো",
          "BRR": "ব্রাজিলিয়ান ক্রুজেয়রো",
          "BRZ": "BRZ",
          "BSD": "বাহামিয়ান ডলার",
          "BTN": "ভুটানি এনগুল্ট্রুম",
          "BUK": "বর্মি কিয়াৎ",
          "BWP": "বতসোয়ানা পুলা",
          "BYB": "বেলারুশিয়ান নিউ রুবেল (১৯৯৪–১৯৯৯)",
          "BYN": "বেলারুশিয়ান রুবেল",
          "BYR": "বেলারুশিয়ান রুবেল (2000–2016)",
          "BZD": "বেলিজ ডলার",
          "CAD": "কানাডিয়ান ডলার",
          "CDF": "কঙ্গোলিস ফ্র্যাঙ্ক",
          "CHE": "সুইজারল্যান্ড ইউরো",
          "CHF": "সুইস ফ্রাঁ",
          "CHW": "সুইজারল্যান্ড ফ্রাঙ্ক",
          "CLE": "CLE",
          "CLF": "চিলিয়ান উনিদাদেস দি ফোমেন্তো",
          "CLP": "চিলি পেসো",
          "CNH": "চাইনিজ ইউয়ান (অফশোর)",
          "CNX": "CNX",
          "CNY": "চীনা য়ুয়ান",
          "COP": "কলোম্বিয়ান পেসো",
          "COU": "উনিদাদ দি ভ্যালোর রিয়েল",
          "CRC": "কোস্টা রিকা কোলোন",
          "CSD": "প্রাচীন সারবিয়ান দিনার",
          "CSK": "চেকোস্লোভাক হার্ড কোরুনা",
          "CUC": "কিউবান রূপান্তরযোগ্য পেসো",
          "CUP": "কিউবান পেসো",
          "CVE": "কেপ ভার্দে এসকুডো",
          "CYP": "সাইপ্রাস পাউন্ড",
          "CZK": "চেক প্রজাতন্ত্র কোরুনা",
          "DDM": "পূর্ব জার্মান মার্ক",
          "DEM": "ডয়চ্ মার্ক",
          "DJF": "জিবুতি ফ্রাঙ্ক",
          "DKK": "ড্যানিশ ক্রোন",
          "DOP": "ডোমিনিকান পেসো",
          "DZD": "আলজেরীয় দিনার",
          "ECS": "ইকুয়াডোর সুক্রে",
          "ECV": "ইকুয়াডোর উনিদাদেস দি ভেলর কনসতান্তে (ইউভিসি)",
          "EEK": "এস্তোনিয়া ক্রুনি",
          "EGP": "মিশরীয় পাউন্ড",
          "ERN": "এরিট্রিয়েন নাকফা",
          "ESA": "স্প্যানিশ পেসেতা (একই হিসাব)",
          "ESB": "স্প্যানিশ পেসেতা (রূপান্তরযোগ্য হিসাব)",
          "ESP": "স্প্যানিশ পেসেতা",
          "ETB": "ইথিওপিয়ান বির",
          "EUR": "ইউরো",
          "FIM": "ফিনিস মার্কা",
          "FJD": "ফিজি ডলার",
          "FKP": "ফকল্যান্ড দ্বীপপুঞ্জ পাউন্ড",
          "FRF": "ফরাসি ফ্রাঙ্ক",
          "GBP": "ব্রিটিশ পাউন্ড",
          "GEK": "জর্জিয়ান কুপন লারিট",
          "GEL": "জর্জিয়ান লারি",
          "GHC": "ঘানা সেডি (১৯৭৯–২০০৭)",
          "GHS": "ঘানা সেডি",
          "GIP": "জিব্রাল্টার পাউন্ড",
          "GMD": "গাম্বিয়া ডালাসি",
          "GNF": "গিনি ফ্রাঙ্ক",
          "GNS": "গিনি সাইলি",
          "GQE": "ইকুয়েটোরিয়াল গিনি ইকুয়িলি",
          "GRD": "গ্রীক দ্রাচমা",
          "GTQ": "গুয়াতেমালা কুয়েৎজাল",
          "GWE": "পর্তুগিজ গিনি এসকুডো",
          "GWP": "গিনি বিসাউ পেসো",
          "GYD": "গাইয়েনা ডলার",
          "HKD": "হংকং ডলার",
          "HNL": "হন্ডুরাস লেম্পিরা",
          "HRD": "ক্রোয়েশিয়ান দিনার",
          "HRK": "ক্রোয়েশিয়ান কুনা",
          "HTG": "হাইতি গৌর্দে",
          "HUF": "হাঙ্গেরিয়ান ফোরিন্ট",
          "IDR": "ইন্দোনেশিয়ান রুপিয়াহ",
          "IEP": "ইরিশ পাউন্ড",
          "ILP": "ইস্রাইলি পাউন্ড",
          "ILR": "ILR",
          "ILS": "ইস্রাইলি নতুন শেকেল",
          "INR": "ভারতীয় রুপি",
          "IQD": "ইরাকি দিনার",
          "IRR": "ইরানিয়ান রিয়াল",
          "ISJ": "ISJ",
          "ISK": "আইসল্যান্ডীয় ক্রোনা",
          "ITL": "ইতালীয় লিরা",
          "JMD": "জামাইকান ডলার",
          "JOD": "জর্ডানিয়ান দিনার",
          "JPY": "জাপানি ইয়েন",
          "KES": "কেনিয়ান শিলিং",
          "KGS": "কিরগিজস্তান সোম",
          "KHR": "কম্বোডিয়ান রিয়েল",
          "KMF": "কম্বোরো ফ্রাঙ্ক",
          "KPW": "উত্তর কোরিয়ার ওন",
          "KRH": "KRH",
          "KRO": "KRO",
          "KRW": "দক্ষিণ কোরিয়ান ওন",
          "KWD": "কুয়েতি দিনার",
          "KYD": "কেম্যান দ্বীপপুঞ্জের ডলার",
          "KZT": "কাজাখাস্তানি টেঙ্গে",
          "LAK": "লেউশান কিপ",
          "LBP": "লেবানিজ পাউন্ড",
          "LKR": "শ্রীলঙ্কান রুপি",
          "LRD": "লিবেরিয়ান ডলার",
          "LSL": "লেসুটু লোটি",
          "LTL": "লিথুইনিয়ান লিটা",
          "LTT": "লিথুইনিয়ান টালোন্যাস",
          "LUC": "লুক্সেমবার্গ রুপান্তযোগ্য ফ্রাঙ্ক",
          "LUF": "লুক্সেমবার্গ ফ্রাঙ্ক",
          "LUL": "লুক্সেমবার্গ ফাইনেনশিয়াল ফ্রাঙ্ক",
          "LVL": "ল্যাটভিয়ান ল্যাট্‌স",
          "LVR": "ল্যাটভিয়ান রুবল",
          "LYD": "লিবিয়ান দিনার",
          "MAD": "মোরোক্কান দিরহাম",
          "MAF": "মোরোক্কান ফ্রাঙ্ক",
          "MCF": "MCF",
          "MDC": "MDC",
          "MDL": "মোল্ডোভান লেয়ু",
          "MGA": "মাদাগাস্কার আরিয়ারি",
          "MGF": "মাদাগাস্কার ফ্রাঙ্ক",
          "MKD": "ম্যাসেডোনিয়ান দিনার",
          "MKN": "MKN",
          "MLF": "মালি ফ্রাঙ্ক",
          "MMK": "মায়ানমার কিয়াত",
          "MNT": "মঙ্গোলিয়ান তুগরিক",
          "MOP": "ম্যাক্যাও পাটাকা",
          "MRO": "মৌরিতানিয়ান ওউগুইয়া (১৯৭৩–২০১৭)",
          "MRU": "মৌরিতানিয়ান ওউগুইয়া",
          "MTL": "মাল্টা লিরা",
          "MTP": "মাল্টা পাউন্ড",
          "MUR": "মৌরিতানিয়ান রুপি",
          "MVP": "MVP",
          "MVR": "মালদিভিয়ান রুফিয়া",
          "MWK": "মালাউইয়ান কওয়াচ",
          "MXN": "ম্যাক্সিকান পেসো",
          "MXP": "ম্যাক্সিকান সিলভার পেসো (১৮৬১–১৯৯২)",
          "MXV": "মেক্সিকান উনিদাদ দি ইনভার্সান (UDI)",
          "MYR": "মালয়েশিয়ান রিঙ্গিৎ",
          "MZE": "মোজাম্বিক এসকুডো",
          "MZM": "প্রাচীন মোজাম্বিক মেটিকেল",
          "MZN": "মোজাম্বিক মেটিকেল",
          "NAD": "নামিবিয়া ডলার",
          "NGN": "নাইজেরিয়ান নায়রা",
          "NIC": "নিকারাগুয়ান কর্ডোবা (১৯৮৮–১৯৯১)",
          "NIO": "নিকারাগুয়ান কর্ডোবা",
          "NLG": "নেদারল্যান্ড গুল্ডের",
          "NOK": "নরওয়েজিয়ান ক্রোন",
          "NPR": "নেপালি রুপি",
          "NZD": "নিউজিল্যান্ড ডলার",
          "OMR": "ওমানি রিয়াল",
          "PAB": "পানামা বেলবোয়া",
          "PEI": "পেরুভিয়ান ইন্তি",
          "PEN": "পেরুভিয়ান সোল",
          "PES": "পেরুভিয়ান সোল (1863–1965)",
          "PGK": "পাপুয়া নিউ গিনিয়ান কিনা",
          "PHP": "ফিলিপাইন পেসো",
          "PKR": "পাকিস্তানি রুপি",
          "PLN": "পোলিশ জ্লোটি",
          "PLZ": "পোলিশ জ্লোটি (১৯৫০–১৯৯৫)",
          "PTE": "পর্তুগিজ এসকুডো",
          "PYG": "প্যারাগুয়ান গুয়ারানি",
          "QAR": "কাতার রিয়াল",
          "RHD": "রোডেশিয়ান ডলার",
          "ROL": "প্রাচীন রুমানিয়া লেয়ু",
          "RON": "রুমানিয়া লেয়ু",
          "RSD": "সারবিয়ান দিনার",
          "RUB": "রাশিয়ান রুবেল",
          "RUR": "রাশিয়ান রুবল (১৯৯১–১৯৯৮)",
          "RWF": "রুয়ান্ডান ফ্রাঙ্ক",
          "SAR": "সৌদি রিয়াল",
          "SBD": "সলোমন দ্বীপপুঞ্জ ডলার",
          "SCR": "সেয়চেল্লোইস রুপি",
          "SDD": "প্রাচীন সুদানি দিনার",
          "SDG": "সুদানি পাউন্ড",
          "SDP": "প্রাচীন সুদানি পাউন্ড",
          "SEK": "সুইডিশ ক্রোনা",
          "SGD": "সিঙ্গাপুর ডলার",
          "SHP": "সেন্ট হেলেনা পাউন্ড",
          "SIT": "স্লোভানিয়া টোলার",
          "SKK": "স্লোভাক কোরুনা",
          "SLL": "সিয়েরালিয়ন লিয়ন",
          "SOS": "সোমালি শিলিং",
          "SRD": "সুরিনাম ডলার",
          "SRG": "সুরিনাম গিল্ডার",
          "SSP": "দক্ষিণ সুদানি পাউন্ড",
          "STD": "সাও টোমে এবং প্রিন্সিপে ডোবরা (১৯৭৭–২০১৭)",
          "STN": "সাও টোমে এবং প্রিন্সিপে ডোবরা",
          "SUR": "সোভিয়েত রুবল",
          "SVC": "এল স্যালভোডোর কোলোন",
          "SYP": "সিরিয়ান পাউন্ড",
          "SZL": "সোয়াজিল্যান্ড লিলাঙ্গেনি",
          "THB": "থাই বাত",
          "TJR": "তাজিকিস্তান রুবল",
          "TJS": "তাজিকিস্তান সোমোনি",
          "TMM": "তুর্কমেনিস্টানি মানাত",
          "TMT": "তুর্কমেনিস্তান মানত",
          "TND": "তিউনেশিয়ান দিনার",
          "TOP": "টোঙ্গা পা’আঙ্গা",
          "TPE": "তিমুর এসকুডো",
          "TRL": "প্রাচীন তুর্কি লিরা",
          "TRY": "তুর্কি লিরা",
          "TTD": "ত্রিনিদাদ এবং টোবাগো ডলার",
          "TWD": "নতুন তাইওয়ান ডলার",
          "TZS": "তাঞ্জনিয়া শিলিং",
          "UAH": "ইউক্রেইন হৃভনিয়া",
          "UAK": "ইউক্রেইন কার্বোভ্যান্টস",
          "UGS": "উগান্ডান শিলিং (১৯৬৬–১৯৮৭)",
          "UGX": "উগান্ডান শিলিং",
          "USD": "মার্কিন ডলার",
          "USN": "মার্কিন ডলার (পরবর্তী দিন)",
          "USS": "মার্কিন ডলার (একই দিন)",
          "UYI": "উরুগুয়ায়ান পেসো এন উনিদাদেস ইনডেক্সেডাস",
          "UYP": "উরুগুয়ে পেসো (১৯৭৫–১৯৯৩)",
          "UYU": "উরুগুয়ে পেসো",
          "UYW": "UYW",
          "UZS": "উজবেকিস্তানি সোম",
          "VEB": "ভেনিজুয়েলান বলিভার (১৮৭১–২০০৮)",
          "VEF": "ভেনিজুয়েলীয় বলিভার (২০০৮–২০১৮)",
          "VES": "ভেনিজুয়েলীয় বলিভার",
          "VND": "ভিয়েতনামি ডঙ্গ",
          "VNN": "VNN",
          "VUV": "ভানুয়াতু ভাতু",
          "WST": "সামোয়ান টালা",
          "XAF": "মধ্য আফ্রিকান [CFA] ফ্র্যাঙ্ক",
          "XAG": "সিলভার",
          "XAU": "গোল্ড",
          "XBA": "XBA",
          "XBB": "ইউরোপীয় আর্থিক একক",
          "XBC": "XBC",
          "XBD": "XBD",
          "XCD": "পূর্ব ক্যারাবিয়ান ডলার",
          "XDR": "XDR",
          "XEU": "ইউরোপীয় মুদ্রা একক",
          "XFO": "ফরাসি গোল্ড ফ্রাঙ্ক",
          "XFU": "ফরাসি ইউআইসি - ফ্রাঙ্ক",
          "XOF": "পশ্চিম আফ্রিকান [CFA] ফ্র্যাঙ্ক",
          "XPD": "প্যালেডিয়াম",
          "XPF": "সিএফপি ফ্র্যাঙ্ক",
          "XPT": "প্লাটিনাম",
          "XRE": "XRE",
          "XSU": "XSU",
          "XTS": "XTS",
          "XUA": "XUA",
          "XXX": "অজানা মুদ্রা",
          "YDD": "ইয়েমেনি দিনার",
          "YER": "ইয়েমেনি রিয়াল",
          "YUD": "যুগোশ্লাভিয় হার্ড দিনার",
          "YUM": "যুগোশ্লাভিয় নোভি দিনার",
          "YUN": "যুগোশ্লাভিয় রুপান্তরযোগ্য দিনার",
          "YUR": "YUR",
          "ZAL": "দক্ষিণ আফ্রিকান র‌্যান্ড",
          "ZAR": "দক্ষিণ আফ্রিকান রেন্ড",
          "ZMK": "জাম্বিয়ান কওয়াচা (১৯৬৮–২০১২)",
          "ZMW": "জাম্বিয়ান কওয়াচা",
          "ZRN": "জাইরিয়ান নিউ জাইরে",
          "ZRZ": "জাইরিয়ান জাইরে",
          "ZWD": "জিম্বাবুয়ে ডলার (১৯৮০–২০০৮)",
          "ZWL": "জিম্বাবুয়ে ডলার (২০০৯)",
          "ZWR": "জিম্বাবুয়ে ডলার (২০০৮)"
        },
        "narrow": {
        },
        "short": {
        }
      },
      "dateTimeField": {
        "long": {
          "day": "দিন",
          "dayOfYear": "বছরের দিন",
          "dayperiod": "AM/PM",
          "era": "যুগ",
          "hour": "ঘণ্টা",
          "minute": "মিনিট",
          "month": "মাস",
          "quarter": "ত্রৈমাসিক",
          "second": "সেকেন্ড",
          "timeZoneName": "সময় অঞ্চল",
          "weekOfMonth": "মাসের সপ্তাহ",
          "weekOfYear": "সপ্তাহ",
          "weekday": "সপ্তাহের দিন",
          "weekdayOfMonth": "মাসের কার্য দিবস",
          "year": "বছর"
        },
        "narrow": {
          "day": "দিন",
          "dayOfYear": "বছরের দিন",
          "dayperiod": "AM/PM",
          "era": "যুগ",
          "hour": "ঘণ্টা",
          "minute": "মিনিট",
          "month": "মাস",
          "quarter": "ত্রৈমাসিক",
          "second": "সেকেন্ড",
          "timeZoneName": "অঞ্চল",
          "weekOfMonth": "মাসের সপ্তাহ",
          "weekOfYear": "সপ্তাহ",
          "weekday": "সপ্তাহের দিন",
          "weekdayOfMonth": "মাসের কার্য দিবস",
          "year": "বছর"
        },
        "short": {
          "day": "দিন",
          "dayOfYear": "বছরের দিন",
          "dayperiod": "AM/PM",
          "era": "যুগ",
          "hour": "ঘণ্টা",
          "minute": "মিনিট",
          "month": "মাস",
          "quarter": "ত্রৈমাসিক",
          "second": "সেকেন্ড",
          "timeZoneName": "অঞ্চল",
          "weekOfMonth": "মাসের সপ্তাহ",
          "weekOfYear": "সপ্তাহ",
          "weekday": "সপ্তাহের দিন",
          "weekdayOfMonth": "মাসের কার্য দিবস",
          "year": "বছর"
        }
      },
      "language": {
        "dialect": {
          "long": {
            "aa": "আফার",
            "ab": "আবখাজিয়ান",
            "ace": "অ্যাচাইনিজ",
            "ach": "আকোলি",
            "ada": "অদাগ্মে",
            "ady": "আদেগে",
            "ae": "আবেস্তীয়",
            "af": "আফ্রিকান",
            "afh": "আফ্রিহিলি",
            "agq": "এঘেম",
            "ain": "আইনু",
            "ak": "আকান",
            "akk": "আক্কাদিয়ান",
            "ale": "আলেউত",
            "alt": "দক্ষিন আলতাই",
            "am": "আমহারিক",
            "an": "আর্গোনিজ",
            "ang": "প্রাচীন ইংরেজী",
            "anp": "আঙ্গিকা",
            "ar": "আরবী",
            "ar-001": "আধুনিক আদর্শ আরবী",
            "arc": "আরামাইক",
            "arn": "মাপুচি",
            "arp": "আরাপাহো",
            "arw": "আরাওয়াক",
            "as": "অসমীয়া",
            "asa": "আসু",
            "ast": "আস্তুরিয়",
            "av": "আভেরিক",
            "awa": "আওয়াধি",
            "ay": "আয়মারা",
            "az": "আজারবাইজানী",
            "ba": "বাশকির",
            "bal": "বেলুচী",
            "ban": "বালিনীয়",
            "bas": "বাসা",
            "be": "বেলারুশিয়",
            "bej": "বেজা",
            "bem": "বেম্বা",
            "bez": "বেনা",
            "bg": "বুলগেরিয়",
            "bgn": "পশ্চিম বালোচি",
            "bho": "ভোজপুরি",
            "bi": "বিসলামা",
            "bik": "বিকোল",
            "bin": "বিনি",
            "bla": "সিকসিকা",
            "bm": "বামবারা",
            "bn": "বাংলা",
            "bo": "তিব্বতি",
            "br": "ব্রেটন",
            "bra": "ব্রাজ",
            "brx": "বোড়ো",
            "bs": "বসনীয়ান",
            "bua": "বুরিয়াত",
            "bug": "বুগিনি",
            "byn": "ব্লিন",
            "ca": "কাতালান",
            "cad": "ক্যাডো",
            "car": "ক্যারিব",
            "cch": "আত্সাম",
            "ccp": "চাকমা",
            "ce": "চেচেন",
            "ceb": "চেবুয়ানো",
            "cgg": "চিগা",
            "ch": "চামোরো",
            "chb": "চিবচা",
            "chg": "চাগাতাই",
            "chk": "চুকি",
            "chm": "মারি",
            "chn": "চিনুক জার্গন",
            "cho": "চকটোও",
            "chp": "চিপেওয়ান",
            "chr": "চেরোকী",
            "chy": "শাইয়েন",
            "ckb": "মধ্য কুর্দিশ",
            "co": "কর্সিকান",
            "cop": "কপটিক",
            "cr": "ক্রি",
            "crh": "ক্রিমিয়ান তুর্কি",
            "crs": "সেসেলওয়া ক্রেওল ফ্রেঞ্চ",
            "cs": "চেক",
            "csb": "কাশুবিয়ান",
            "cu": "চার্চ স্লাভিক",
            "cv": "চুবাস",
            "cy": "ওয়েলশ",
            "da": "ডেনিশ",
            "dak": "ডাকোটা",
            "dar": "দার্গওয়া",
            "dav": "তাইতা",
            "de": "জার্মান",
            "de-AT": "অস্ট্রিয়ান জার্মান",
            "de-CH": "সুইস হাই জার্মান",
            "del": "ডেলাওয়ের",
            "den": "স্ল্যাভ",
            "dgr": "দোগ্রীব",
            "din": "ডিংকা",
            "dje": "জার্মা",
            "doi": "ডোগরি",
            "dsb": "নিম্নতর সোর্বিয়ান",
            "dua": "দুয়ালা",
            "dum": "মধ্য ডাচ",
            "dv": "দিবেহি",
            "dyo": "জোলা-ফনী",
            "dyu": "ডিউলা",
            "dz": "জোঙ্গা",
            "dzg": "দাজাগা",
            "ebu": "এম্বু",
            "ee": "ইউয়ি",
            "efi": "এফিক",
            "egy": "প্রাচীন মিশরীয়",
            "eka": "ইকাজুক",
            "el": "গ্রিক",
            "elx": "এলামাইট",
            "en": "ইংরেজি",
            "en-AU": "অস্ট্রেলীয় ইংরেজি",
            "en-CA": "কানাডীয় ইংরেজি",
            "en-GB": "ব্রিটিশ ইংরেজি",
            "en-US": "আমেরিকার ইংরেজি",
            "enm": "মধ্য ইংরেজি",
            "eo": "এস্পেরান্তো",
            "es": "স্প্যানিশ",
            "es-419": "ল্যাটিন আমেরিকান স্প্যানিশ",
            "es-ES": "ইউরোপীয় স্প্যানিশ",
            "es-MX": "ম্যাক্সিকান স্প্যানিশ",
            "et": "এস্তোনীয়",
            "eu": "বাস্ক",
            "ewo": "ইওন্ডো",
            "fa": "ফার্সি",
            "fa-AF": "দারি",
            "fan": "ফ্যাঙ্গ",
            "fat": "ফান্তি",
            "ff": "ফুলাহ্",
            "fi": "ফিনিশ",
            "fil": "ফিলিপিনো",
            "fj": "ফিজিআন",
            "fo": "ফারোস",
            "fon": "ফন",
            "fr": "ফরাসি",
            "fr-CA": "কানাডীয় ফরাসি",
            "fr-CH": "সুইস ফরাসি",
            "frc": "কাজুন ফরাসি",
            "frm": "মধ্য ফরাসি",
            "fro": "প্রাচীন ফরাসি",
            "frr": "উত্তরাঞ্চলীয় ফ্রিসিয়ান",
            "frs": "পূর্ব ফ্রিসিয়",
            "fur": "ফ্রিউলিয়ান",
            "fy": "পশ্চিম ফ্রিসিয়ান",
            "ga": "আইরিশ",
            "gaa": "গা",
            "gag": "গাগাউজ",
            "gan": "gan",
            "gay": "গায়ো",
            "gba": "বায়া",
            "gd": "স্কটস-গ্যেলিক",
            "gez": "গীজ",
            "gil": "গিলবার্টিজ",
            "gl": "গ্যালিশিয়",
            "gmh": "মধ্য-উচ্চ জার্মানি",
            "gn": "গুয়ারানি",
            "goh": "প্রাচীন উচ্চ জার্মানি",
            "gon": "গোন্ডি",
            "gor": "গোরোন্তালো",
            "got": "গথিক",
            "grb": "গ্রেবো",
            "grc": "প্রাচীন গ্রীক",
            "gsw": "সুইস জার্মান",
            "gu": "গুজরাটি",
            "guz": "গুসী",
            "gv": "ম্যাঙ্কস",
            "gwi": "গওইচ্’ইন",
            "ha": "হাউসা",
            "hai": "হাইডা",
            "haw": "হাওয়াইয়ান",
            "he": "হিব্রু",
            "hi": "হিন্দি",
            "hil": "হিলিগ্যায়নোন",
            "hit": "হিট্টিট",
            "hmn": "হ্‌মোঙ",
            "ho": "হিরি মোতু",
            "hr": "ক্রোয়েশীয়",
            "hsb": "উচ্চ সোর্বিয়ান",
            "hsn": "Xiang চীনা",
            "ht": "হাইতিয়ান ক্রেওল",
            "hu": "হাঙ্গেরীয়",
            "hup": "হুপা",
            "hy": "আর্মেনিয়",
            "hz": "হেরেরো",
            "ia": "ইন্টারলিঙ্গুয়া",
            "iba": "ইবান",
            "ibb": "ইবিবিও",
            "id": "ইন্দোনেশীয়",
            "ie": "ইন্টারলিঙ্গ",
            "ig": "ইগ্‌বো",
            "ii": "সিচুয়ান য়ি",
            "ik": "ইনুপিয়াক",
            "ilo": "ইলোকো",
            "inh": "ইঙ্গুশ",
            "io": "ইডো",
            "is": "আইসল্যান্ডীয়",
            "it": "ইতালিয়",
            "iu": "ইনুক্টিটুট",
            "ja": "জাপানি",
            "jbo": "লোজবান",
            "jgo": "গোম্বা",
            "jmc": "মাকামে",
            "jpr": "জুদেও ফার্সি",
            "jrb": "জুদেও আরবি",
            "jv": "জাভানিজ",
            "ka": "জর্জিয়ান",
            "kaa": "কারা-কাল্পাক",
            "kab": "কাবাইলে",
            "kac": "কাচিন",
            "kaj": "অজ্জু",
            "kam": "কাম্বা",
            "kaw": "কাউই",
            "kbd": "কাবার্ডিয়ান",
            "kcg": "টাইয়াপ",
            "kde": "মাকোন্দে",
            "kea": "কাবুভারদিয়ানু",
            "kfo": "কোরো",
            "kg": "কঙ্গো",
            "kgp": "kgp",
            "kha": "খাশি",
            "kho": "খোটানিজ",
            "khq": "কোয়রা চীনি",
            "ki": "কিকুয়ু",
            "kj": "কোয়ানিয়ামা",
            "kk": "কাজাখ",
            "kkj": "কাকো",
            "kl": "ক্যালাল্লিসুট",
            "kln": "কালেনজিন",
            "km": "খমের",
            "kmb": "কিম্বুন্দু",
            "kn": "কন্নড়",
            "ko": "কোরিয়ান",
            "koi": "কমি-পারমিআক",
            "kok": "কোঙ্কানি",
            "kos": "কোস্রাইন",
            "kpe": "ক্‌পেল্লে",
            "kr": "কানুরি",
            "krc": "কারচে-বাল্কার",
            "krl": "কারেলিয়ান",
            "kru": "কুরুখ",
            "ks": "কাশ্মীরি",
            "ksb": "শাম্বালা",
            "ksf": "বাফিয়া",
            "ksh": "কোলোনিয়ান",
            "ku": "কুর্দিশ",
            "kum": "কুমিক",
            "kut": "কুটেনাই",
            "kv": "কোমি",
            "kw": "কর্ণিশ",
            "ky": "কির্গিজ",
            "la": "লাতিন",
            "lad": "লাডিনো",
            "lag": "লাঙ্গি",
            "lah": "লান্ডা",
            "lam": "লাম্বা",
            "lb": "লুক্সেমবার্গীয়",
            "lez": "লেজঘিয়ান",
            "lg": "গান্ডা",
            "li": "লিম্বুর্গিশ",
            "lij": "lij",
            "lkt": "লাকোটা",
            "ln": "লিঙ্গালা",
            "lo": "লাও",
            "lol": "মোঙ্গো",
            "lou": "লুইসিয়ানা ক্রেওল",
            "loz": "লোজি",
            "lrc": "উত্তর লুরি",
            "lt": "লিথুয়েনীয়",
            "lu": "লুবা-কাটাঙ্গা",
            "lua": "লুবা-লুলুয়া",
            "lui": "লুইসেনো",
            "lun": "লুন্ডা",
            "luo": "লুয়ো",
            "lus": "মিজো",
            "luy": "লুইয়া",
            "lv": "লাত্‌ভীয়",
            "mad": "মাদুরেসে",
            "mag": "মাগাহি",
            "mai": "মৈথিলি",
            "mak": "ম্যাকাসার",
            "man": "ম্যান্ডিঙ্গো",
            "mas": "মাসাই",
            "mdf": "মোকশা",
            "mdr": "ম্যাণ্ডার",
            "men": "মেন্ডে",
            "mer": "মেরু",
            "mfe": "মরিসিয়ান",
            "mg": "মালাগাসি",
            "mga": "মধ্য আইরিশ",
            "mgh": "মাখুয়া-মেত্তো",
            "mgo": "মেটা",
            "mh": "মার্শালিজ",
            "mi": "মাওরি",
            "mic": "মিকম্যাক",
            "min": "মিনাংকাবাউ",
            "mk": "ম্যাসিডোনীয়",
            "ml": "মালায়ালাম",
            "mn": "মঙ্গোলিয়",
            "mnc": "মাঞ্চু",
            "mni": "মণিপুরী",
            "moh": "মোহাওক",
            "mos": "মসি",
            "mr": "মারাঠি",
            "ms": "মালয়",
            "mt": "মল্টিয়",
            "mua": "মুদাঙ্গ",
            "mul": "একাধিক ভাষা",
            "mus": "ক্রিক",
            "mwl": "মিরান্ডিজ",
            "mwr": "মারোয়ারি",
            "my": "বর্মি",
            "myv": "এরজিয়া",
            "mzn": "মাজানদেরানি",
            "na": "নাউরু",
            "nap": "নেয়াপোলিটান",
            "naq": "নামা",
            "nb": "নরওয়েজিয়ান বোকমাল",
            "nd": "উত্তর এন্দেবিলি",
            "nds": "নিম্ন জার্মানি",
            "nds-NL": "লো স্যাক্সন",
            "ne": "নেপালী",
            "new": "নেওয়ারি",
            "ng": "এন্দোঙ্গা",
            "nia": "নিয়াস",
            "niu": "নিউয়ান",
            "nl": "ওলন্দাজ",
            "nl-BE": "ফ্লেমিশ",
            "nmg": "কোয়াসিও",
            "nn": "নরওয়েজিয়ান নিনর্স্ক",
            "nnh": "নিঙ্গেম্বুন",
            "no": "নরওয়েজীয়",
            "nog": "নোগাই",
            "non": "প্রাচীন নর্স",
            "nqo": "এন’কো",
            "nr": "দক্ষিণ এনডেবেলে",
            "nso": "উত্তরাঞ্চলীয় সোথো",
            "nus": "নুয়ার",
            "nv": "নাভাজো",
            "nwc": "প্রাচীন নেওয়ারী",
            "ny": "নায়াঞ্জা",
            "nym": "ন্যায়ামওয়েজি",
            "nyn": "ন্যায়াঙ্কোলে",
            "nyo": "ন্যোরো",
            "nzi": "এনজিমা",
            "oc": "অক্সিটান",
            "oj": "ওজিবওয়া",
            "om": "অরোমো",
            "or": "ওড়িয়া",
            "os": "ওসেটিক",
            "osa": "ওসেজ",
            "ota": "অটোমান তুর্কি",
            "pa": "পাঞ্জাবী",
            "pag": "পাঙ্গাসিনান",
            "pal": "পাহ্লাভি",
            "pam": "পাম্পাঙ্গা",
            "pap": "পাপিয়ামেন্টো",
            "pau": "পালায়ুয়ান",
            "pcm": "নাইজেরিয় পিজিন",
            "peo": "প্রাচীন ফার্সি",
            "phn": "ফোনিশীয়ান",
            "pi": "পালি",
            "pl": "পোলিশ",
            "pon": "পোহ্নপেইয়ান",
            "prg": "প্রুশিয়ান",
            "pro": "প্রাচীন প্রোভেনসাল",
            "ps": "পুশতু",
            "pt": "পর্তুগীজ",
            "pt-BR": "ব্রাজিলের পর্তুগীজ",
            "pt-PT": "ইউরোপের পর্তুগীজ",
            "qu": "কেচুয়া",
            "quc": "কি‘চে",
            "raj": "রাজস্থানী",
            "rap": "রাপানুই",
            "rar": "রারোটোংগান",
            "rhg": "রোহিঙ্গা",
            "rm": "রোমান্স",
            "rn": "রুন্দি",
            "ro": "রোমানীয়",
            "ro-MD": "মলদাভিয়",
            "rof": "রম্বো",
            "rom": "রোমানি",
            "ru": "রুশ",
            "rup": "আরমেনিয়ান",
            "rw": "কিনয়ারোয়ান্ডা",
            "rwk": "রাওয়া",
            "sa": "সংস্কৃত",
            "sad": "স্যান্ডাওয়ে",
            "sah": "শাখা",
            "sam": "সামারিটান আরামিক",
            "saq": "সামবুরু",
            "sas": "সাসাক",
            "sat": "সাঁওতালি",
            "sba": "ন্যাগাম্বে",
            "sbp": "সাঙ্গু",
            "sc": "সার্ডিনিয়ান",
            "scn": "সিসিলিয়ান",
            "sco": "স্কটস",
            "sd": "সিন্ধি",
            "sdh": "দক্ষিণ কুর্দিশ",
            "se": "উত্তরাঞ্চলীয় সামি",
            "seh": "সেনা",
            "sel": "সেল্কুপ",
            "ses": "কোয়রাবেনো সেন্নী",
            "sg": "সাঙ্গো",
            "sga": "প্রাচীন আইরিশ",
            "sh": "সার্বো-ক্রোয়েশিয়",
            "shi": "তাচেলহিত",
            "shn": "শান",
            "si": "সিংহলী",
            "sid": "সিডামো",
            "sk": "স্লোভাক",
            "sl": "স্লোভেনীয়",
            "sm": "সামোয়ান",
            "sma": "দক্ষিণাঞ্চলীয় সামি",
            "smj": "লুলে সামি",
            "smn": "ইনারি সামি",
            "sms": "স্কোল্ট সামি",
            "sn": "শোনা",
            "snk": "সোনিঙ্কে",
            "so": "সোমালি",
            "sog": "সোগডিয়ান",
            "sq": "আলবেনীয়",
            "sr": "সার্বীয়",
            "srn": "স্রানান টোঙ্গো",
            "srr": "সেরের",
            "ss": "সোয়াতি",
            "ssy": "সাহো",
            "st": "দক্ষিন সোথো",
            "su": "সুদানী",
            "suk": "সুকুমা",
            "sus": "সুসু",
            "sux": "সুমেরীয়",
            "sv": "সুইডিশ",
            "sw": "সোয়াহিলি",
            "sw-CD": "কঙ্গো সোয়াহিলি",
            "swb": "কমোরিয়ান",
            "syc": "প্রাচীন সিরিও",
            "syr": "সিরিয়াক",
            "ta": "তামিল",
            "te": "তেলুগু",
            "tem": "টাইম্নে",
            "teo": "তেসো",
            "ter": "তেরেনো",
            "tet": "তেতুম",
            "tg": "তাজিক",
            "th": "থাই",
            "ti": "তিগরিনিয়া",
            "tig": "টাইগ্রে",
            "tiv": "টিভ",
            "tk": "তুর্কমেনী",
            "tkl": "টোকেলাউ",
            "tl": "তাগালগ",
            "tlh": "ক্লিঙ্গন",
            "tli": "ত্লিঙ্গিট",
            "tmh": "তামাশেক",
            "tn": "সোয়ানা",
            "to": "টোঙ্গান",
            "tog": "নায়াসা টোঙ্গা",
            "tpi": "টোক পিসিন",
            "tr": "তুর্কী",
            "trv": "তারোকো",
            "ts": "সঙ্গা",
            "tsi": "সিমশিয়ান",
            "tt": "তাতার",
            "tum": "তুম্বুকা",
            "tvl": "টুভালু",
            "tw": "টোয়াই",
            "twq": "তাসাওয়াক",
            "ty": "তাহিতিয়ান",
            "tyv": "টুভিনিয়ান",
            "tzm": "সেন্ট্রাল আটলাস তামাজিগাত",
            "udm": "উডমুর্ট",
            "ug": "উইঘুর",
            "uga": "উগারিটিক",
            "uk": "ইউক্রেনীয়",
            "umb": "উম্বুন্দু",
            "und": "অজানা ভাষা",
            "ur": "উর্দু",
            "uz": "উজবেকীয়",
            "vai": "ভাই",
            "ve": "ভেন্ডা",
            "vi": "ভিয়েতনামী",
            "vo": "ভোলাপুক",
            "vot": "ভোটিক",
            "vun": "ভুঞ্জো",
            "wa": "ওয়ালুন",
            "wae": "ওয়ালসের",
            "wal": "ওয়ালামো",
            "war": "ওয়ারে",
            "was": "ওয়াশো",
            "wbp": "ওয়ার্লপিরি",
            "wo": "উওলোফ",
            "wuu": "Wu চীনা",
            "xal": "কাল্মইক",
            "xh": "জোসা",
            "xog": "সোগা",
            "yao": "ইয়াও",
            "yap": "ইয়াপেসে",
            "yav": "ইয়াঙ্গবেন",
            "ybb": "ইয়েম্বা",
            "yi": "ইয়েদ্দিশ",
            "yo": "ইওরুবা",
            "yrl": "yrl",
            "yue": "ক্যান্টোনিজ",
            "za": "ঝু্য়াঙ",
            "zap": "জাপোটেক",
            "zbl": "চিত্র ভাষা",
            "zen": "জেনাগা",
            "zgh": "আদর্শ মরক্কোন তামাজিগাত",
            "zh": "চীনা",
            "zh-Hans": "সরলীকৃত চীনা",
            "zh-Hant": "ঐতিহ্যবাহি চীনা",
            "zu": "জুলু",
            "zun": "জুনি",
            "zxx": "ভাষাভিত্তিক বিষয়বস্তু নেই",
            "zza": "জাজা"
          },
          "narrow": {
          },
          "short": {
            "az": "আজেরি",
            "en-GB": "যুক্তরাজ্যের ইংরেজি",
            "en-US": "যুক্তরাষ্ট্রের ইংরেজি"
          }
        },
        "standard": {
          "long": {
            "aa": "আফার",
            "ab": "আবখাজিয়ান",
            "ace": "অ্যাচাইনিজ",
            "ach": "আকোলি",
            "ada": "অদাগ্মে",
            "ady": "আদেগে",
            "ae": "আবেস্তীয়",
            "af": "আফ্রিকান",
            "afh": "আফ্রিহিলি",
            "agq": "এঘেম",
            "ain": "আইনু",
            "ak": "আকান",
            "akk": "আক্কাদিয়ান",
            "ale": "আলেউত",
            "alt": "দক্ষিন আলতাই",
            "am": "আমহারিক",
            "an": "আর্গোনিজ",
            "ang": "প্রাচীন ইংরেজী",
            "anp": "আঙ্গিকা",
            "ar": "আরবী",
            "ar-001": "আরবী (পৃথিবী)",
            "arc": "আরামাইক",
            "arn": "মাপুচি",
            "arp": "আরাপাহো",
            "arw": "আরাওয়াক",
            "as": "অসমীয়া",
            "asa": "আসু",
            "ast": "আস্তুরিয়",
            "av": "আভেরিক",
            "awa": "আওয়াধি",
            "ay": "আয়মারা",
            "az": "আজারবাইজানী",
            "ba": "বাশকির",
            "bal": "বেলুচী",
            "ban": "বালিনীয়",
            "bas": "বাসা",
            "be": "বেলারুশিয়",
            "bej": "বেজা",
            "bem": "বেম্বা",
            "bez": "বেনা",
            "bg": "বুলগেরিয়",
            "bgn": "পশ্চিম বালোচি",
            "bho": "ভোজপুরি",
            "bi": "বিসলামা",
            "bik": "বিকোল",
            "bin": "বিনি",
            "bla": "সিকসিকা",
            "bm": "বামবারা",
            "bn": "বাংলা",
            "bo": "তিব্বতি",
            "br": "ব্রেটন",
            "bra": "ব্রাজ",
            "brx": "বোড়ো",
            "bs": "বসনীয়ান",
            "bua": "বুরিয়াত",
            "bug": "বুগিনি",
            "byn": "ব্লিন",
            "ca": "কাতালান",
            "cad": "ক্যাডো",
            "car": "ক্যারিব",
            "cch": "আত্সাম",
            "ccp": "চাকমা",
            "ce": "চেচেন",
            "ceb": "চেবুয়ানো",
            "cgg": "চিগা",
            "ch": "চামোরো",
            "chb": "চিবচা",
            "chg": "চাগাতাই",
            "chk": "চুকি",
            "chm": "মারি",
            "chn": "চিনুক জার্গন",
            "cho": "চকটোও",
            "chp": "চিপেওয়ান",
            "chr": "চেরোকী",
            "chy": "শাইয়েন",
            "ckb": "মধ্য কুর্দিশ",
            "co": "কর্সিকান",
            "cop": "কপটিক",
            "cr": "ক্রি",
            "crh": "ক্রিমিয়ান তুর্কি",
            "crs": "সেসেলওয়া ক্রেওল ফ্রেঞ্চ",
            "cs": "চেক",
            "csb": "কাশুবিয়ান",
            "cu": "চার্চ স্লাভিক",
            "cv": "চুবাস",
            "cy": "ওয়েলশ",
            "da": "ডেনিশ",
            "dak": "ডাকোটা",
            "dar": "দার্গওয়া",
            "dav": "তাইতা",
            "de": "জার্মান",
            "de-AT": "জার্মান (অস্ট্রিয়া)",
            "de-CH": "জার্মান (সুইজারল্যান্ড)",
            "del": "ডেলাওয়ের",
            "den": "স্ল্যাভ",
            "dgr": "দোগ্রীব",
            "din": "ডিংকা",
            "dje": "জার্মা",
            "doi": "ডোগরি",
            "dsb": "নিম্নতর সোর্বিয়ান",
            "dua": "দুয়ালা",
            "dum": "মধ্য ডাচ",
            "dv": "দিবেহি",
            "dyo": "জোলা-ফনী",
            "dyu": "ডিউলা",
            "dz": "জোঙ্গা",
            "dzg": "দাজাগা",
            "ebu": "এম্বু",
            "ee": "ইউয়ি",
            "efi": "এফিক",
            "egy": "প্রাচীন মিশরীয়",
            "eka": "ইকাজুক",
            "el": "গ্রিক",
            "elx": "এলামাইট",
            "en": "ইংরেজি",
            "en-AU": "ইংরেজি (অস্ট্রেলিয়া)",
            "en-CA": "ইংরেজি (কানাডা)",
            "en-GB": "ইংরেজি (যুক্তরাজ্য)",
            "en-US": "ইংরেজি (মার্কিন যুক্তরাষ্ট্র)",
            "enm": "মধ্য ইংরেজি",
            "eo": "এস্পেরান্তো",
            "es": "স্প্যানিশ",
            "es-419": "স্প্যানিশ (ল্যাটিন আমেরিকা)",
            "es-ES": "স্প্যানিশ (স্পেন)",
            "es-MX": "স্প্যানিশ (মেক্সিকো)",
            "et": "এস্তোনীয়",
            "eu": "বাস্ক",
            "ewo": "ইওন্ডো",
            "fa": "ফার্সি",
            "fa-AF": "ফার্সি (আফগানিস্তান)",
            "fan": "ফ্যাঙ্গ",
            "fat": "ফান্তি",
            "ff": "ফুলাহ্",
            "fi": "ফিনিশ",
            "fil": "ফিলিপিনো",
            "fj": "ফিজিআন",
            "fo": "ফারোস",
            "fon": "ফন",
            "fr": "ফরাসি",
            "fr-CA": "ফরাসি (কানাডা)",
            "fr-CH": "ফরাসি (সুইজারল্যান্ড)",
            "frc": "কাজুন ফরাসি",
            "frm": "মধ্য ফরাসি",
            "fro": "প্রাচীন ফরাসি",
            "frr": "উত্তরাঞ্চলীয় ফ্রিসিয়ান",
            "frs": "পূর্ব ফ্রিসিয়",
            "fur": "ফ্রিউলিয়ান",
            "fy": "পশ্চিম ফ্রিসিয়ান",
            "ga": "আইরিশ",
            "gaa": "গা",
            "gag": "গাগাউজ",
            "gan": "gan",
            "gay": "গায়ো",
            "gba": "বায়া",
            "gd": "স্কটস-গ্যেলিক",
            "gez": "গীজ",
            "gil": "গিলবার্টিজ",
            "gl": "গ্যালিশিয়",
            "gmh": "মধ্য-উচ্চ জার্মানি",
            "gn": "গুয়ারানি",
            "goh": "প্রাচীন উচ্চ জার্মানি",
            "gon": "গোন্ডি",
            "gor": "গোরোন্তালো",
            "got": "গথিক",
            "grb": "গ্রেবো",
            "grc": "প্রাচীন গ্রীক",
            "gsw": "সুইস জার্মান",
            "gu": "গুজরাটি",
            "guz": "গুসী",
            "gv": "ম্যাঙ্কস",
            "gwi": "গওইচ্’ইন",
            "ha": "হাউসা",
            "hai": "হাইডা",
            "haw": "হাওয়াইয়ান",
            "he": "হিব্রু",
            "hi": "হিন্দি",
            "hil": "হিলিগ্যায়নোন",
            "hit": "হিট্টিট",
            "hmn": "হ্‌মোঙ",
            "ho": "হিরি মোতু",
            "hr": "ক্রোয়েশীয়",
            "hsb": "উচ্চ সোর্বিয়ান",
            "hsn": "Xiang চীনা",
            "ht": "হাইতিয়ান ক্রেওল",
            "hu": "হাঙ্গেরীয়",
            "hup": "হুপা",
            "hy": "আর্মেনিয়",
            "hz": "হেরেরো",
            "ia": "ইন্টারলিঙ্গুয়া",
            "iba": "ইবান",
            "ibb": "ইবিবিও",
            "id": "ইন্দোনেশীয়",
            "ie": "ইন্টারলিঙ্গ",
            "ig": "ইগ্‌বো",
            "ii": "সিচুয়ান য়ি",
            "ik": "ইনুপিয়াক",
            "ilo": "ইলোকো",
            "inh": "ইঙ্গুশ",
            "io": "ইডো",
            "is": "আইসল্যান্ডীয়",
            "it": "ইতালিয়",
            "iu": "ইনুক্টিটুট",
            "ja": "জাপানি",
            "jbo": "লোজবান",
            "jgo": "গোম্বা",
            "jmc": "মাকামে",
            "jpr": "জুদেও ফার্সি",
            "jrb": "জুদেও আরবি",
            "jv": "জাভানিজ",
            "ka": "জর্জিয়ান",
            "kaa": "কারা-কাল্পাক",
            "kab": "কাবাইলে",
            "kac": "কাচিন",
            "kaj": "অজ্জু",
            "kam": "কাম্বা",
            "kaw": "কাউই",
            "kbd": "কাবার্ডিয়ান",
            "kcg": "টাইয়াপ",
            "kde": "মাকোন্দে",
            "kea": "কাবুভারদিয়ানু",
            "kfo": "কোরো",
            "kg": "কঙ্গো",
            "kgp": "kgp",
            "kha": "খাশি",
            "kho": "খোটানিজ",
            "khq": "কোয়রা চীনি",
            "ki": "কিকুয়ু",
            "kj": "কোয়ানিয়ামা",
            "kk": "কাজাখ",
            "kkj": "কাকো",
            "kl": "ক্যালাল্লিসুট",
            "kln": "কালেনজিন",
            "km": "খমের",
            "kmb": "কিম্বুন্দু",
            "kn": "কন্নড়",
            "ko": "কোরিয়ান",
            "koi": "কমি-পারমিআক",
            "kok": "কোঙ্কানি",
            "kos": "কোস্রাইন",
            "kpe": "ক্‌পেল্লে",
            "kr": "কানুরি",
            "krc": "কারচে-বাল্কার",
            "krl": "কারেলিয়ান",
            "kru": "কুরুখ",
            "ks": "কাশ্মীরি",
            "ksb": "শাম্বালা",
            "ksf": "বাফিয়া",
            "ksh": "কোলোনিয়ান",
            "ku": "কুর্দিশ",
            "kum": "কুমিক",
            "kut": "কুটেনাই",
            "kv": "কোমি",
            "kw": "কর্ণিশ",
            "ky": "কির্গিজ",
            "la": "লাতিন",
            "lad": "লাডিনো",
            "lag": "লাঙ্গি",
            "lah": "লান্ডা",
            "lam": "লাম্বা",
            "lb": "লুক্সেমবার্গীয়",
            "lez": "লেজঘিয়ান",
            "lg": "গান্ডা",
            "li": "লিম্বুর্গিশ",
            "lij": "lij",
            "lkt": "লাকোটা",
            "ln": "লিঙ্গালা",
            "lo": "লাও",
            "lol": "মোঙ্গো",
            "lou": "লুইসিয়ানা ক্রেওল",
            "loz": "লোজি",
            "lrc": "উত্তর লুরি",
            "lt": "লিথুয়েনীয়",
            "lu": "লুবা-কাটাঙ্গা",
            "lua": "লুবা-লুলুয়া",
            "lui": "লুইসেনো",
            "lun": "লুন্ডা",
            "luo": "লুয়ো",
            "lus": "মিজো",
            "luy": "লুইয়া",
            "lv": "লাত্‌ভীয়",
            "mad": "মাদুরেসে",
            "mag": "মাগাহি",
            "mai": "মৈথিলি",
            "mak": "ম্যাকাসার",
            "man": "ম্যান্ডিঙ্গো",
            "mas": "মাসাই",
            "mdf": "মোকশা",
            "mdr": "ম্যাণ্ডার",
            "men": "মেন্ডে",
            "mer": "মেরু",
            "mfe": "মরিসিয়ান",
            "mg": "মালাগাসি",
            "mga": "মধ্য আইরিশ",
            "mgh": "মাখুয়া-মেত্তো",
            "mgo": "মেটা",
            "mh": "মার্শালিজ",
            "mi": "মাওরি",
            "mic": "মিকম্যাক",
            "min": "মিনাংকাবাউ",
            "mk": "ম্যাসিডোনীয়",
            "ml": "মালায়ালাম",
            "mn": "মঙ্গোলিয়",
            "mnc": "মাঞ্চু",
            "mni": "মণিপুরী",
            "moh": "মোহাওক",
            "mos": "মসি",
            "mr": "মারাঠি",
            "ms": "মালয়",
            "mt": "মল্টিয়",
            "mua": "মুদাঙ্গ",
            "mul": "একাধিক ভাষা",
            "mus": "ক্রিক",
            "mwl": "মিরান্ডিজ",
            "mwr": "মারোয়ারি",
            "my": "বর্মি",
            "myv": "এরজিয়া",
            "mzn": "মাজানদেরানি",
            "na": "নাউরু",
            "nap": "নেয়াপোলিটান",
            "naq": "নামা",
            "nb": "নরওয়েজিয়ান বোকমাল",
            "nd": "উত্তর এন্দেবিলি",
            "nds": "নিম্ন জার্মানি",
            "nds-NL": "নিম্ন জার্মানি (নেদারল্যান্ডস)",
            "ne": "নেপালী",
            "new": "নেওয়ারি",
            "ng": "এন্দোঙ্গা",
            "nia": "নিয়াস",
            "niu": "নিউয়ান",
            "nl": "ওলন্দাজ",
            "nl-BE": "ওলন্দাজ (বেলজিয়াম)",
            "nmg": "কোয়াসিও",
            "nn": "নরওয়েজিয়ান নিনর্স্ক",
            "nnh": "নিঙ্গেম্বুন",
            "no": "নরওয়েজীয়",
            "nog": "নোগাই",
            "non": "প্রাচীন নর্স",
            "nqo": "এন’কো",
            "nr": "দক্ষিণ এনডেবেলে",
            "nso": "উত্তরাঞ্চলীয় সোথো",
            "nus": "নুয়ার",
            "nv": "নাভাজো",
            "nwc": "প্রাচীন নেওয়ারী",
            "ny": "নায়াঞ্জা",
            "nym": "ন্যায়ামওয়েজি",
            "nyn": "ন্যায়াঙ্কোলে",
            "nyo": "ন্যোরো",
            "nzi": "এনজিমা",
            "oc": "অক্সিটান",
            "oj": "ওজিবওয়া",
            "om": "অরোমো",
            "or": "ওড়িয়া",
            "os": "ওসেটিক",
            "osa": "ওসেজ",
            "ota": "অটোমান তুর্কি",
            "pa": "পাঞ্জাবী",
            "pag": "পাঙ্গাসিনান",
            "pal": "পাহ্লাভি",
            "pam": "পাম্পাঙ্গা",
            "pap": "পাপিয়ামেন্টো",
            "pau": "পালায়ুয়ান",
            "pcm": "নাইজেরিয় পিজিন",
            "peo": "প্রাচীন ফার্সি",
            "phn": "ফোনিশীয়ান",
            "pi": "পালি",
            "pl": "পোলিশ",
            "pon": "পোহ্নপেইয়ান",
            "prg": "প্রুশিয়ান",
            "pro": "প্রাচীন প্রোভেনসাল",
            "ps": "পুশতু",
            "pt": "পর্তুগীজ",
            "pt-BR": "পর্তুগীজ (ব্রাজিল)",
            "pt-PT": "পর্তুগীজ (পর্তুগাল)",
            "qu": "কেচুয়া",
            "quc": "কি‘চে",
            "raj": "রাজস্থানী",
            "rap": "রাপানুই",
            "rar": "রারোটোংগান",
            "rhg": "রোহিঙ্গা",
            "rm": "রোমান্স",
            "rn": "রুন্দি",
            "ro": "রোমানীয়",
            "ro-MD": "রোমানীয় (মলডোভা)",
            "rof": "রম্বো",
            "rom": "রোমানি",
            "ru": "রুশ",
            "rup": "আরমেনিয়ান",
            "rw": "কিনয়ারোয়ান্ডা",
            "rwk": "রাওয়া",
            "sa": "সংস্কৃত",
            "sad": "স্যান্ডাওয়ে",
            "sah": "শাখা",
            "sam": "সামারিটান আরামিক",
            "saq": "সামবুরু",
            "sas": "সাসাক",
            "sat": "সাঁওতালি",
            "sba": "ন্যাগাম্বে",
            "sbp": "সাঙ্গু",
            "sc": "সার্ডিনিয়ান",
            "scn": "সিসিলিয়ান",
            "sco": "স্কটস",
            "sd": "সিন্ধি",
            "sdh": "দক্ষিণ কুর্দিশ",
            "se": "উত্তরাঞ্চলীয় সামি",
            "seh": "সেনা",
            "sel": "সেল্কুপ",
            "ses": "কোয়রাবেনো সেন্নী",
            "sg": "সাঙ্গো",
            "sga": "প্রাচীন আইরিশ",
            "sh": "সার্বো-ক্রোয়েশিয়",
            "shi": "তাচেলহিত",
            "shn": "শান",
            "si": "সিংহলী",
            "sid": "সিডামো",
            "sk": "স্লোভাক",
            "sl": "স্লোভেনীয়",
            "sm": "সামোয়ান",
            "sma": "দক্ষিণাঞ্চলীয় সামি",
            "smj": "লুলে সামি",
            "smn": "ইনারি সামি",
            "sms": "স্কোল্ট সামি",
            "sn": "শোনা",
            "snk": "সোনিঙ্কে",
            "so": "সোমালি",
            "sog": "সোগডিয়ান",
            "sq": "আলবেনীয়",
            "sr": "সার্বীয়",
            "srn": "স্রানান টোঙ্গো",
            "srr": "সেরের",
            "ss": "সোয়াতি",
            "ssy": "সাহো",
            "st": "দক্ষিন সোথো",
            "su": "সুদানী",
            "suk": "সুকুমা",
            "sus": "সুসু",
            "sux": "সুমেরীয়",
            "sv": "সুইডিশ",
            "sw": "সোয়াহিলি",
            "sw-CD": "সোয়াহিলি (কঙ্গো-কিনশাসা)",
            "swb": "কমোরিয়ান",
            "syc": "প্রাচীন সিরিও",
            "syr": "সিরিয়াক",
            "ta": "তামিল",
            "te": "তেলুগু",
            "tem": "টাইম্নে",
            "teo": "তেসো",
            "ter": "তেরেনো",
            "tet": "তেতুম",
            "tg": "তাজিক",
            "th": "থাই",
            "ti": "তিগরিনিয়া",
            "tig": "টাইগ্রে",
            "tiv": "টিভ",
            "tk": "তুর্কমেনী",
            "tkl": "টোকেলাউ",
            "tl": "তাগালগ",
            "tlh": "ক্লিঙ্গন",
            "tli": "ত্লিঙ্গিট",
            "tmh": "তামাশেক",
            "tn": "সোয়ানা",
            "to": "টোঙ্গান",
            "tog": "নায়াসা টোঙ্গা",
            "tpi": "টোক পিসিন",
            "tr": "তুর্কী",
            "trv": "তারোকো",
            "ts": "সঙ্গা",
            "tsi": "সিমশিয়ান",
            "tt": "তাতার",
            "tum": "তুম্বুকা",
            "tvl": "টুভালু",
            "tw": "টোয়াই",
            "twq": "তাসাওয়াক",
            "ty": "তাহিতিয়ান",
            "tyv": "টুভিনিয়ান",
            "tzm": "সেন্ট্রাল আটলাস তামাজিগাত",
            "udm": "উডমুর্ট",
            "ug": "উইঘুর",
            "uga": "উগারিটিক",
            "uk": "ইউক্রেনীয়",
            "umb": "উম্বুন্দু",
            "und": "অজানা ভাষা",
            "ur": "উর্দু",
            "uz": "উজবেকীয়",
            "vai": "ভাই",
            "ve": "ভেন্ডা",
            "vi": "ভিয়েতনামী",
            "vo": "ভোলাপুক",
            "vot": "ভোটিক",
            "vun": "ভুঞ্জো",
            "wa": "ওয়ালুন",
            "wae": "ওয়ালসের",
            "wal": "ওয়ালামো",
            "war": "ওয়ারে",
            "was": "ওয়াশো",
            "wbp": "ওয়ার্লপিরি",
            "wo": "উওলোফ",
            "wuu": "Wu চীনা",
            "xal": "কাল্মইক",
            "xh": "জোসা",
            "xog": "সোগা",
            "yao": "ইয়াও",
            "yap": "ইয়াপেসে",
            "yav": "ইয়াঙ্গবেন",
            "ybb": "ইয়েম্বা",
            "yi": "ইয়েদ্দিশ",
            "yo": "ইওরুবা",
            "yrl": "yrl",
            "yue": "ক্যান্টোনিজ",
            "za": "ঝু্য়াঙ",
            "zap": "জাপোটেক",
            "zbl": "চিত্র ভাষা",
            "zen": "জেনাগা",
            "zgh": "আদর্শ মরক্কোন তামাজিগাত",
            "zh": "চীনা",
            "zh-Hans": "সরলীকৃত চীনা",
            "zh-Hant": "ঐতিহ্যবাহি চীনা",
            "zu": "জুলু",
            "zun": "জুনি",
            "zxx": "ভাষাভিত্তিক বিষয়বস্তু নেই",
            "zza": "জাজা"
          },
          "narrow": {
          },
          "short": {
            "az": "আজেরি",
            "en-GB": "ইংরেজি (ইউ কে)",
            "en-US": "ইংরেজি (ইউ এস)"
          }
        }
      },
      "region": {
        "long": {
          "001": "পৃথিবী",
          "002": "আফ্রিকা",
          "003": "উত্তর আমেরিকা",
          "005": "দক্ষিণ আমেরিকা",
          "009": "ওশিয়ানিয়া",
          "011": "পশ্চিম আফ্রিকা",
          "013": "মধ্য আমেরিকা",
          "014": "পূর্ব আফ্রিকা",
          "015": "উত্তর আফ্রিকা",
          "017": "মধ্য আফ্রিকা",
          "018": "দক্ষিন আফ্রিকা",
          "019": "আমেরিকাস",
          "021": "উত্তরাঞ্চলীয় আমেরিকা",
          "029": "ক্যারাবিয়ান",
          "030": "পূর্ব এশিয়া",
          "034": "দক্ষিণ এশিয়া",
          "035": "দক্ষিণ পূর্ব এশিয়া",
          "039": "দক্ষিণ ইউরোপ",
          "053": "অস্ট্রালেশিয়া",
          "054": "ম্যালেনেশিয়া",
          "057": "মাইক্রোনেশিয়া অঞ্চল",
          "061": "পলিনেশিয়া",
          "142": "এশিয়া",
          "143": "মধ্য এশিয়া",
          "145": "পশ্চিম এশিয়া",
          "150": "ইউরোপ",
          "151": "পূর্ব ইউরোপ",
          "154": "উত্তর ইউরোপ",
          "155": "পশ্চিম ইউরোপ",
          "202": "উপ সাহারান আফ্রিকা",
          "419": "ল্যাটিন আমেরিকা",
          "AC": "অ্যাসসেনশন আইল্যান্ড",
          "AD": "আন্ডোরা",
          "AE": "সংযুক্ত আরব আমিরাত",
          "AF": "আফগানিস্তান",
          "AG": "অ্যান্টিগুয়া ও বারবুডা",
          "AI": "এ্যাঙ্গুইলা",
          "AL": "আলবেনিয়া",
          "AM": "আর্মেনিয়া",
          "AO": "অ্যাঙ্গোলা",
          "AQ": "অ্যান্টার্কটিকা",
          "AR": "আর্জেন্টিনা",
          "AS": "আমেরিকান সামোয়া",
          "AT": "অস্ট্রিয়া",
          "AU": "অস্ট্রেলিয়া",
          "AW": "আরুবা",
          "AX": "আলান্ড দ্বীপপুঞ্জ",
          "AZ": "আজারবাইজান",
          "BA": "বসনিয়া ও হার্জেগোভিনা",
          "BB": "বারবাদোস",
          "BD": "বাংলাদেশ",
          "BE": "বেলজিয়াম",
          "BF": "বুরকিনা ফাসো",
          "BG": "বুলগেরিয়া",
          "BH": "বাহরাইন",
          "BI": "বুরুন্ডি",
          "BJ": "বেনিন",
          "BL": "সেন্ট বারথেলিমি",
          "BM": "বারমুডা",
          "BN": "ব্রুনেই",
          "BO": "বলিভিয়া",
          "BQ": "ক্যারিবিয়ান নেদারল্যান্ডস",
          "BR": "ব্রাজিল",
          "BS": "বাহামা দ্বীপপুঞ্জ",
          "BT": "ভুটান",
          "BV": "বোভেট দ্বীপ",
          "BW": "বতসোয়ানা",
          "BY": "বেলারুশ",
          "BZ": "বেলিজ",
          "CA": "কানাডা",
          "CC": "কোকোস (কিলিং) দ্বীপপুঞ্জ",
          "CD": "কঙ্গো-কিনশাসা",
          "CF": "মধ্য আফ্রিকার প্রজাতন্ত্র",
          "CG": "কঙ্গো - ব্রাজাভিল",
          "CH": "সুইজারল্যান্ড",
          "CI": "কোত দিভোয়ার",
          "CK": "কুক দ্বীপপুঞ্জ",
          "CL": "চিলি",
          "CM": "ক্যামেরুন",
          "CN": "চীন",
          "CO": "কলম্বিয়া",
          "CP": "ক্লিপারটন আইল্যান্ড",
          "CR": "কোস্টারিকা",
          "CU": "কিউবা",
          "CV": "কেপভার্দে",
          "CW": "কুরাসাও",
          "CX": "ক্রিসমাস দ্বীপ",
          "CY": "সাইপ্রাস",
          "CZ": "চেচিয়া",
          "DE": "জার্মানি",
          "DG": "দিয়েগো গার্সিয়া",
          "DJ": "জিবুতি",
          "DK": "ডেনমার্ক",
          "DM": "ডোমিনিকা",
          "DO": "ডোমেনিকান প্রজাতন্ত্র",
          "DZ": "আলজেরিয়া",
          "EA": "কুউটা এবং মেলিলা",
          "EC": "ইকুয়েডর",
          "EE": "এস্তোনিয়া",
          "EG": "মিশর",
          "EH": "পশ্চিম সাহারা",
          "ER": "ইরিত্রিয়া",
          "ES": "স্পেন",
          "ET": "ইথিওপিয়া",
          "EU": "ইউরোপীয় ইউনিয়ন",
          "EZ": "ইউরোজোন",
          "FI": "ফিনল্যান্ড",
          "FJ": "ফিজি",
          "FK": "ফকল্যান্ড দ্বীপপুঞ্জ",
          "FM": "মাইক্রোনেশিয়া",
          "FO": "ফ্যারও দ্বীপপুঞ্জ",
          "FR": "ফ্রান্স",
          "GA": "গ্যাবন",
          "GB": "যুক্তরাজ্য",
          "GD": "গ্রেনাডা",
          "GE": "জর্জিয়া",
          "GF": "ফরাসী গায়ানা",
          "GG": "গুয়ার্নসি",
          "GH": "ঘানা",
          "GI": "জিব্রাল্টার",
          "GL": "গ্রীনল্যান্ড",
          "GM": "গাম্বিয়া",
          "GN": "গিনি",
          "GP": "গুয়াদেলৌপ",
          "GQ": "নিরক্ষীয় গিনি",
          "GR": "গ্রীস",
          "GS": "দক্ষিণ জর্জিয়া ও দক্ষিণ স্যান্ডউইচ দ্বীপপুঞ্জ",
          "GT": "গুয়াতেমালা",
          "GU": "গুয়াম",
          "GW": "গিনি-বিসাউ",
          "GY": "গিয়ানা",
          "HK": "হংকং এসএআর চীনা",
          "HM": "হার্ড এবং ম্যাকডোনাল্ড দ্বীপপুঞ্জ",
          "HN": "হন্ডুরাস",
          "HR": "ক্রোয়েশিয়া",
          "HT": "হাইতি",
          "HU": "হাঙ্গেরি",
          "IC": "ক্যানারি দ্বীপপুঞ্জ",
          "ID": "ইন্দোনেশিয়া",
          "IE": "আয়ারল্যান্ড",
          "IL": "ইজরায়েল",
          "IM": "আইল অফ ম্যান",
          "IN": "ভারত",
          "IO": "ব্রিটিশ ভারত মহাসাগরীয় অঞ্চল",
          "IQ": "ইরাক",
          "IR": "ইরান",
          "IS": "আইসল্যান্ড",
          "IT": "ইতালি",
          "JE": "জার্সি",
          "JM": "জামাইকা",
          "JO": "জর্ডন",
          "JP": "জাপান",
          "KE": "কেনিয়া",
          "KG": "কিরগিজিস্তান",
          "KH": "কম্বোডিয়া",
          "KI": "কিরিবাতি",
          "KM": "কমোরোস",
          "KN": "সেন্ট কিটস ও নেভিস",
          "KP": "উত্তর কোরিয়া",
          "KR": "দক্ষিণ কোরিয়া",
          "KW": "কুয়েত",
          "KY": "কেম্যান দ্বীপপুঞ্জ",
          "KZ": "কাজাখস্তান",
          "LA": "লাওস",
          "LB": "লেবানন",
          "LC": "সেন্ট লুসিয়া",
          "LI": "লিচেনস্টেইন",
          "LK": "শ্রীলঙ্কা",
          "LR": "লাইবেরিয়া",
          "LS": "লেসোথো",
          "LT": "লিথুয়ানিয়া",
          "LU": "লাক্সেমবার্গ",
          "LV": "লাত্ভিয়া",
          "LY": "লিবিয়া",
          "MA": "মোরক্কো",
          "MC": "মোনাকো",
          "MD": "মলডোভা",
          "ME": "মন্টিনিগ্রো",
          "MF": "সেন্ট মার্টিন",
          "MG": "মাদাগাস্কার",
          "MH": "মার্শাল দ্বীপপুঞ্জ",
          "MK": "উত্তর ম্যাসেডোনিয়া",
          "ML": "মালি",
          "MM": "মায়ানমার (বার্মা)",
          "MN": "মঙ্গোলিয়া",
          "MO": "ম্যাকাও এসএআর চীনা চীনা (ম্যাকাও এসএআর চীনা) চীনা (ঐতিহ্যবাহী, ম্যাকাও এসএআর চীনা) অঞ্চল: ম্যাকাও এসএআর চীন",
          "MP": "উত্তরাঞ্চলীয় মারিয়ানা দ্বীপপুঞ্জ",
          "MQ": "মার্টিনিক",
          "MR": "মরিতানিয়া",
          "MS": "মন্টসেরাট",
          "MT": "মাল্টা",
          "MU": "মরিশাস",
          "MV": "মালদ্বীপ",
          "MW": "মালাউই",
          "MX": "মেক্সিকো",
          "MY": "মালয়েশিয়া",
          "MZ": "মোজাম্বিক",
          "NA": "নামিবিয়া",
          "NC": "নিউ ক্যালেডোনিয়া",
          "NE": "নাইজার",
          "NF": "নরফোক দ্বীপ",
          "NG": "নাইজেরিয়া",
          "NI": "নিকারাগুয়া",
          "NL": "নেদারল্যান্ডস",
          "NO": "নরওয়ে",
          "NP": "নেপাল",
          "NR": "নাউরু",
          "NU": "নিউয়ে",
          "NZ": "নিউজিল্যান্ড",
          "OM": "ওমান",
          "PA": "পানামা",
          "PE": "পেরু",
          "PF": "ফরাসী পলিনেশিয়া",
          "PG": "পাপুয়া নিউ গিনি",
          "PH": "ফিলিপাইন",
          "PK": "পাকিস্তান",
          "PL": "পোল্যান্ড",
          "PM": "সেন্ট পিয়ের ও মিকুয়েলন",
          "PN": "পিটকেয়ার্ন দ্বীপপুঞ্জ",
          "PR": "পুয়ের্তো রিকো",
          "PS": "প্যালেস্টাইনের অঞ্চলসমূহ",
          "PT": "পর্তুগাল",
          "PW": "পালাউ",
          "PY": "প্যারাগুয়ে",
          "QA": "কাতার",
          "QO": "আউটলাইনিং ওসানিয়া",
          "RE": "রিইউনিয়ন",
          "RO": "রোমানিয়া",
          "RS": "সার্বিয়া",
          "RU": "রাশিয়া",
          "RW": "রুয়ান্ডা",
          "SA": "সৌদি আরব",
          "SB": "সলোমন দ্বীপপুঞ্জ",
          "SC": "সিসিলি",
          "SD": "সুদান",
          "SE": "সুইডেন",
          "SG": "সিঙ্গাপুর",
          "SH": "সেন্ট হেলেনা",
          "SI": "স্লোভানিয়া",
          "SJ": "স্বালবার্ড ও জান মেয়েন",
          "SK": "স্লোভাকিয়া",
          "SL": "সিয়েরা লিওন",
          "SM": "সান মারিনো",
          "SN": "সেনেগাল",
          "SO": "সোমালিয়া",
          "SR": "সুরিনাম",
          "SS": "দক্ষিণ সুদান",
          "ST": "সাওটোমা ও প্রিন্সিপি",
          "SV": "এল সালভেদর",
          "SX": "সিন্ট মার্টেন",
          "SY": "সিরিয়া",
          "SZ": "ইসওয়াতিনি",
          "TA": "ট্রিস্টান ডা কুনহা",
          "TC": "তুর্কস ও কাইকোস দ্বীপপুঞ্জ",
          "TD": "চাদ",
          "TF": "ফরাসী দক্ষিণাঞ্চল",
          "TG": "টোগো",
          "TH": "থাইল্যান্ড",
          "TJ": "তাজিকিস্তান",
          "TK": "টোকেলাউ",
          "TL": "তিমুর-লেস্তে",
          "TM": "তুর্কমেনিস্তান",
          "TN": "তিউনিসিয়া",
          "TO": "টোঙ্গা",
          "TR": "তুরস্ক",
          "TT": "ত্রিনিনাদ ও টোব্যাগো",
          "TV": "টুভালু",
          "TW": "তাইওয়ান",
          "TZ": "তাঞ্জানিয়া",
          "UA": "ইউক্রেন",
          "UG": "উগান্ডা",
          "UM": "মার্কিন যুক্তরাষ্ট্রের পার্শ্ববর্তী দ্বীপপুঞ্জ",
          "UN": "জাতিসংঘ",
          "US": "মার্কিন যুক্তরাষ্ট্র",
          "UY": "উরুগুয়ে",
          "UZ": "উজবেকিস্তান",
          "VA": "ভ্যাটিকান সিটি",
          "VC": "সেন্ট ভিনসেন্ট ও গ্রেনাডিনস",
          "VE": "ভেনেজুয়েলা",
          "VG": "ব্রিটিশ ভার্জিন দ্বীপপুঞ্জ",
          "VI": "মার্কিন যুক্তরাষ্ট্রের ভার্জিন দ্বীপপুঞ্জ",
          "VN": "ভিয়েতনাম",
          "VU": "ভানুয়াটু",
          "WF": "ওয়ালিস ও ফুটুনা",
          "WS": "সামোয়া",
          "XA": "সিউডো-অ্যাকসেন্ট",
          "XB": "সিউডো-বিডি",
          "XK": "কসোভো",
          "YE": "ইয়েমেন",
          "YT": "মায়োত্তে",
          "ZA": "দক্ষিণ আফ্রিকা",
          "ZM": "জাম্বিয়া",
          "ZW": "জিম্বাবোয়ে",
          "ZZ": "অজানা অঞ্চল"
        },
        "narrow": {
        },
        "short": {
          "GB": "ইউ কে",
          "HK": "হংকং",
          "MO": "ম্যাকাও",
          "PS": "ফিলিস্তিন",
          "UN": "ইউএন",
          "US": "ইউ এস"
        }
      },
      "script": {
        "long": {
          "Adlm": "Adlm",
          "Aghb": "Aghb",
          "Ahom": "Ahom",
          "Arab": "আরবি",
          "Aran": "Aran",
          "Armi": "আরমি",
          "Armn": "আর্মেনীয়",
          "Avst": "আভেসতান",
          "Bali": "বালীয়",
          "Bamu": "Bamu",
          "Bass": "Bass",
          "Batk": "বাটাক",
          "Beng": "বাংলা",
          "Bhks": "Bhks",
          "Blis": "ব্লিসপ্রতীক",
          "Bopo": "বোপোমোফো",
          "Brah": "ব্রাহ্মী",
          "Brai": "ব্রেইল",
          "Bugi": "বুগি",
          "Buhd": "বুহিড",
          "Cakm": "চাকমা",
          "Cans": "সংযুক্ত কানাডিয়ান অ্যাব্রোজিনিয়ান সিলেবিক্স",
          "Cari": "ক্যারিয়ান",
          "Cham": "চ্যাম",
          "Cher": "চেরোকি",
          "Chrs": "Chrs",
          "Cirt": "কির্ট",
          "Copt": "কোপ্টিক",
          "Cpmn": "Cpmn",
          "Cprt": "সাইপ্রোয়েট",
          "Cyrl": "সিরিলিক",
          "Cyrs": "প্রাচীন চার্চ স্লাভোনিক সিরিলিক",
          "Deva": "দেবনাগরি",
          "Diak": "Diak",
          "Dogr": "Dogr",
          "Dsrt": "দেসেরাত",
          "Dupl": "Dupl",
          "Egyd": "মিশরীয় ডেমোটিক",
          "Egyh": "মিশরীয় হায়রেটিক",
          "Egyp": "মিশরীয় হায়ারোগ্লিপ",
          "Elba": "Elba",
          "Elym": "Elym",
          "Ethi": "ইথিওপিয়",
          "Geok": "জর্জিয় খুৎসুরি",
          "Geor": "জর্জিয়ান",
          "Glag": "গ্লাগোলিটিক",
          "Gong": "Gong",
          "Gonm": "Gonm",
          "Goth": "গোথিক",
          "Gran": "Gran",
          "Grek": "গ্রিক",
          "Gujr": "গুজরাটি",
          "Guru": "গুরুমুখি",
          "Hanb": "হ্যানবি",
          "Hang": "হাঙ্গুল",
          "Hani": "হ্যান",
          "Hano": "হ্যানুনু",
          "Hans": "সরলীকৃত",
          "Hant": "ঐতিহ্যবাহী",
          "Hatr": "Hatr",
          "Hebr": "হিব্রু",
          "Hira": "হিরাগানা",
          "Hluw": "Hluw",
          "Hmng": "ফাহাও মঙ",
          "Hmnp": "Hmnp",
          "Hrkt": "জাপানি অক্ষরমালা",
          "Hung": "পুরোনো হাঙ্গেরীয়",
          "Inds": "সিন্ধু",
          "Ital": "প্রাচীন ইতালি",
          "Jamo": "জ্যামো",
          "Java": "জাভানিজ",
          "Jpan": "জাপানী",
          "Kali": "কায়াহ লি",
          "Kana": "কাটাকানা",
          "Khar": "খরোষ্ঠী",
          "Khmr": "খেমের",
          "Khoj": "Khoj",
          "Kits": "Kits",
          "Knda": "কানাড়া",
          "Kore": "কোরিয়ান",
          "Kthi": "কাইথি",
          "Lana": "লান্না",
          "Laoo": "লাও",
          "Latf": "ফ্রাক্টুর ল্যাটিন",
          "Latg": "গ্যালিক ল্যাটিন",
          "Latn": "ল্যাটিন",
          "Lepc": "লেপ্চা",
          "Limb": "লিম্বু",
          "Lina": "লিনিয়ার এ",
          "Linb": "লিনিয়ার বি",
          "Lisu": "Lisu",
          "Lyci": "লাইসিয়ান",
          "Lydi": "লাইডিয়ান",
          "Mahj": "Mahj",
          "Maka": "Maka",
          "Mand": "ম্যান্ডায়ীন",
          "Mani": "ম্যানিচাইন",
          "Marc": "Marc",
          "Maya": "মায়ান হায়ারোগ্লিপ",
          "Medf": "Medf",
          "Mend": "Mend",
          "Merc": "Merc",
          "Mero": "মেরোইটিক",
          "Mlym": "মালায়ালাম",
          "Modi": "Modi",
          "Mong": "মোঙ্গোলীয়",
          "Moon": "মুন",
          "Mroo": "Mroo",
          "Mtei": "মেইটেই মায়েক",
          "Mult": "Mult",
          "Mymr": "মায়ানমার",
          "Nand": "Nand",
          "Narb": "Narb",
          "Nbat": "Nbat",
          "Newa": "Newa",
          "Nkoo": "এনকো",
          "Nshu": "Nshu",
          "Ogam": "ওঘাম",
          "Olck": "ওল চিকি",
          "Orkh": "অর্খোন",
          "Orya": "ওড়িয়া",
          "Osge": "Osge",
          "Osma": "ওসমানিয়",
          "Ougr": "Ougr",
          "Palm": "Palm",
          "Pauc": "Pauc",
          "Perm": "প্রাচীন পার্মিক",
          "Phag": "ফাগ্স-পা",
          "Phli": "খদিত পাহলভি",
          "Phlp": "সল্টার পাহলভি",
          "Phlv": "পুস্তক পাহলভি",
          "Phnx": "ফিনিশিয়",
          "Plrd": "পোলার্ড ধ্বনিক",
          "Prti": "পার্থিয়ন",
          "Qaag": "Qaag",
          "Rjng": "রেজ্যাঙ্গ",
          "Rohg": "Rohg",
          "Roro": "রোঙ্গোরোঙ্গো",
          "Runr": "রুনিক",
          "Samr": "সমেরিটন",
          "Sara": "সারাতি",
          "Sarb": "Sarb",
          "Saur": "সৌরাষ্ট্র",
          "Sgnw": "চিহ্ন লিখন",
          "Shaw": "সাভিয়ান",
          "Shrd": "Shrd",
          "Sidd": "Sidd",
          "Sind": "Sind",
          "Sinh": "সিংহলি",
          "Sogd": "Sogd",
          "Sogo": "Sogo",
          "Sora": "Sora",
          "Soyo": "Soyo",
          "Sund": "সান্দানিজ",
          "Sylo": "সিলেটি নাগরি",
          "Syrc": "সিরিয়াক",
          "Syre": "এস্ট্রেঙ্গেলো সিরিয়াক",
          "Syrj": "পশ্চিমাঞ্চলীয় সিরিয়াক",
          "Syrn": "পূর্বাঞ্চলীয় সিরিয়াক",
          "Tagb": "টাগোওয়ানা",
          "Takr": "Takr",
          "Tale": "তাইলে",
          "Talu": "নতুন তাই লু",
          "Taml": "তামিল",
          "Tang": "Tang",
          "Tavt": "তাই ভিয়েৎ",
          "Telu": "তেলেগু",
          "Teng": "তেঙ্গোয়ার",
          "Tfng": "তিফিনাগ",
          "Tglg": "টাগালগ",
          "Thaa": "থানা",
          "Thai": "থাই",
          "Tibt": "তিব্বতি",
          "Tirh": "Tirh",
          "Tnsa": "Tnsa",
          "Toto": "Toto",
          "Ugar": "উগারিটিক",
          "Vaii": "ভাই",
          "Visp": "দৃশ্যমান ভাষা",
          "Vith": "Vith",
          "Wara": "Wara",
          "Wcho": "Wcho",
          "Xpeo": "প্রাচীন ফার্সি",
          "Xsux": "সুমের-আক্কাদীয় কীলকরূপ",
          "Yezi": "Yezi",
          "Yiii": "উই",
          "Zanb": "Zanb",
          "Zinh": "কাই",
          "Zmth": "গাণিতিক চিহ্ন",
          "Zsye": "ইমোজি",
          "Zsym": "প্রতীকগুলি",
          "Zxxx": "অলিখিত",
          "Zyyy": "সাধারন",
          "Zzzz": "অজানা লিপি"
        },
        "narrow": {
        },
        "short": {
        }
      }
    }
  },
  "locale": "bn-IN"
})
}